import { render, staticRenderFns } from "./AIUpsellModals.vue?vue&type=template&id=615ef7ce&"
import script from "./AIUpsellModals.vue?vue&type=script&lang=js&"
export * from "./AIUpsellModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports